export default __webpack_public_path__ + "static/media/jocelyn_solo.d8b98231.jpg";